'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.silenceErrorAlert = undefined;

var _buildErrorMetaObject = require('./buildErrorMetaObject');

/**
 * @description Build a error meta action to silence floating error alerts
 * @returns {Object} Meta Action
 *
 * @example
 * const pollThreadListFailed = createAction(
 *   POLL_THREAD_LISTS_FAILED,
 *   error => ({ error }),
 *   silenceErrorAlert
 *  );
 */
var silenceErrorAlert = exports.silenceErrorAlert = function silenceErrorAlert() {
  return (0, _buildErrorMetaObject.buildErrorMetaObject)({ silent: true });
};